import { StylesObject } from '../../types/styles'
import { mq, SITE_VARIABLES } from '../../themes/variables'

interface GroupOfLinksPropsStylesObject extends StylesObject {
    wrapper: StylesObject
    linkWrapper: StylesObject
    link: StylesObject
    circle: StylesObject
}

export const getDefaultGroupOfLinksStylesObj = (siteVars: typeof SITE_VARIABLES): GroupOfLinksPropsStylesObject => {
    const { TYPOGRAPHY, COLORS } = siteVars

    return {
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
        },
        link: {
            textDecoration: 'none',
            textAlign: 'start',
            color: COLORS.PRIMARY,
            fontWeight: TYPOGRAPHY.fontWeight,
            fontFamily: TYPOGRAPHY.fontFamily,
            [mq[1]]: {
                fontSize: TYPOGRAPHY.screenSizes.medium,
            },
            [mq[2]]: {
                fontSize: TYPOGRAPHY.screenSizes.large,
            },
        },
        circle: {
            color: COLORS.PRIMARY,
            marginRight: '8px',
        },
        linkWrapper: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px',
        },
    }
}
